var _rect, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBxUserAttributes(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_16600_22822",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 16,
    height: 16
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_16600_22822)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9.33334 4.66683V3.3335H14.6667V4.66683H9.33334ZM9.33334 7.3335V6.00016H14.6667V7.3335H9.33334ZM9.33334 10.0002V8.66683H14.6667V10.0002H9.33334ZM5.33334 9.3335C4.77779 9.3335 4.30557 9.13905 3.91668 8.75016C3.52779 8.36127 3.33334 7.88905 3.33334 7.3335C3.33334 6.77794 3.52779 6.30572 3.91668 5.91683C4.30557 5.52794 4.77779 5.3335 5.33334 5.3335C5.8889 5.3335 6.36112 5.52794 6.75001 5.91683C7.1389 6.30572 7.33334 6.77794 7.33334 7.3335C7.33334 7.88905 7.1389 8.36127 6.75001 8.75016C6.36112 9.13905 5.8889 9.3335 5.33334 9.3335ZM1.33334 13.3335V12.0668C1.33334 11.8335 1.3889 11.6113 1.50001 11.4002C1.61112 11.1891 1.76668 11.0224 1.96668 10.9002C2.46668 10.6002 2.99723 10.3752 3.55834 10.2252C4.11945 10.0752 4.71112 10.0002 5.33334 10.0002C5.95557 10.0002 6.54723 10.0752 7.10834 10.2252C7.66946 10.3752 8.20001 10.6002 8.70001 10.9002C8.90001 11.0224 9.05557 11.1891 9.16668 11.4002C9.27779 11.6113 9.33334 11.8335 9.33334 12.0668V13.3335H1.33334ZM2.76668 12.0002H7.90001C7.51112 11.7779 7.10001 11.6113 6.66668 11.5002C6.23334 11.3891 5.7889 11.3335 5.33334 11.3335C4.87779 11.3335 4.43334 11.3891 4.00001 11.5002C3.56668 11.6113 3.15557 11.7779 2.76668 12.0002ZM5.33334 8.00016C5.52223 8.00016 5.68057 7.93627 5.80834 7.8085C5.93612 7.68072 6.00001 7.52239 6.00001 7.3335C6.00001 7.14461 5.93612 6.98627 5.80834 6.8585C5.68057 6.73072 5.52223 6.66683 5.33334 6.66683C5.14445 6.66683 4.98612 6.73072 4.85834 6.8585C4.73057 6.98627 4.66668 7.14461 4.66668 7.3335C4.66668 7.52239 4.73057 7.68072 4.85834 7.8085C4.98612 7.93627 5.14445 8.00016 5.33334 8.00016Z",
    fill: "#495057"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBxUserAttributes);
export default __webpack_public_path__ + "static/media/bx-user-attributes.c0cde479b0fbd23ce90a42bc8e0afda0.svg";
export { ForwardRef as ReactComponent };